exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".confirm-dialog .dialog-text[data-v-4b297612] {\n  padding: 2em 2em 3em;\n}\n", ""]);

// exports
